const segoeUiBold =   'Lato-Regular'

export const Styles = {
    primaryFontFamily:'Lato-Regular',
    secondaryFontFamily: 'Roboto-Regular',
    segoeUiBold,
    // themeColor: '#3758DB',
    themeColor: '#0775ff',
    secondaryColor: '#FF0000',
    tabColor: '#F5891F',
    waringColor: '#F5591F',
    successColor: "#08C425",
    planningInfo: '#4D6EFF',
    bgLight: "#9F9F9F",
    bgDark: "#000000",
    bgLightDark: "#454545",
    subScriptionColor: "#FF6A00",
    white: '#FFFFFF',
    blackMedium: "#393C54",
    blackDark: "#333333",
    blackLight: '#CBCBCC',
    priceColor: "#7D7A81",
    libraryText: "#404B63",
    pdfTextColor: "#B8C0C9",
    examSubjectTopicColor: "#6F84A6",
    testSeriesListColor: "#555555",
    testSeriesHeader: '#1C1C1C',
    dangerColor:'#FF3939',
    // themeColor: "#f4511e",
    themeColor: '#0775ff',
    fiveMantraBgColor: '#ecf2f7',
    green: '#08C425',
    red: '#FF0303',
    // primaryColor: "#f4511e", //2thepoint
    // primaryColor: "#0775ff", //athena
    primaryColor: "#2E3192",
    sideNavColor: '#e6a800',
    secondaryThemeColor: '#f4511e',
    primaryLight: "#F5891F",
    lightDarkColor: '#656363',
    poppinFontFamily: "Poppins-Regular",
    flex_row: {
        flexDirection: 'row'
    },
    flex_column: {
        flexDirection: 'column'
    }
}

